export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/fabio-mangione-f26c34bb88eb83d5aae99c7dbf3ddd48.jpg";